import { Dialog, DialogHeader } from "@material-tailwind/react";
import { Fragment, useEffect, useState } from "react";
import CSVUploader from "../../Components/Functionality/CSVUploader";
import { ContactsSelectModal } from "../../Components/Functionality/ReusableContactsDisplay";
import { usePlan } from "../../Context/PlanContext";
import DownloadSampleCSV from "../../Utils/DownloadSampleCSV";

const CSVContacts = ({ selectedMembers, setSelectedMembers }) => {
  const [contacts, setContacts] = useState([]);
  const [displayContacts, setDisplayContacts] = useState([]);
  const [openMemberSelect, setOpenMemberSelect] = useState(false);

  const { currentPlan } = usePlan();

  useEffect(() => {
    setDisplayContacts(contacts);
  }, [contacts]);

  const onConfirm = (selectedContacts) => {
    setSelectedMembers(selectedContacts);
    setOpenMemberSelect(false);
  };

  return (
    <Fragment>
      <Dialog open={openMemberSelect} handler={setOpenMemberSelect}>
        <DialogHeader>Select Contacts</DialogHeader>

        <ContactsSelectModal
          onClose={() => setOpenMemberSelect(false)}
          contacts={displayContacts}
          onConfirm={onConfirm}
          open={openMemberSelect}
          selectedContacts={selectedMembers}
          limit={currentPlan?.maxAddUserPerForum}
          loading={false}
        />
      </Dialog>
      <CSVUploader
        selectedContacts={selectedMembers}
        setDisplayContacts={setDisplayContacts}
        setContacts={setContacts}
        setOpenMemberSelect={setOpenMemberSelect}
      />
      <DownloadSampleCSV />
    </Fragment>
  );
};

export default CSVContacts;
